'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _aphrodite = require('aphrodite');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styles = _aphrodite.StyleSheet.create({
	centered: {
		display: 'flex',
		justifyContent: 'center'
	},
	toolCheckbox: {
		':before': {
			overflow: 'hidden'
		}
	},
	helpIcon: {
		position: 'relative',
		color: '#005EA6',
		cursor: 'pointer',
		textDecoration: 'none',
		top: 3
	},
	giftaidit: {
		padding: '25px 38px',
		border: '1px solid #ccc',
		borderRadius: 8,
		width: '100%',
		margin: '10px auto 15px auto',
		maxWidth: 400
	},
	imgWrapper: {
		display: 'block',
		margin: '0px auto 8px auto'
	},
	showHelp: {
		color: '#848b8e',
		marginTop: 15,
		marginLeft: 42,
		textAlign: 'left'
	},
	giftaidNote: {
		marginBottom: 20,
		fontSize: 14,
		textAlign: 'left'
	},
	pTag: {
		fontSize: 14,
		marginBottom: 15,
		textAlign: 'left'
	},
	showAddres: {
		marginTop: 15,
		marginLeft: 42,
		color: '#2c2e2f',
		borderBottom: '1px solid #ccc',
		paddingBottom: 13,
		textAlign: 'left'
	},
	listUnstyled: {
		margin: 0,
		listStyle: 'none'
	},
	liTag: {
		marginBottom: 2
	},
	successIcon: {
		marginLeft: -5,
		paddingRight: 5,
		color: '#00cf92'
	},
	modalContent: {
		background: 'none',
		boxShadow: 'none'
	},
	modalHeader: {
		textAlign: 'right'
	},
	alreadyEnabled: {
		textAlign: 'left',
		fontSize: 14
	},
	updateGiftAidDeclaration: {
		borderTop: '1px solid #ccc',
		paddingTop: 15,
		fontSize: 14
	}
});

var DonateGiftAid = function (_React$Component) {
	_inherits(DonateGiftAid, _React$Component);

	function DonateGiftAid(props) {
		_classCallCheck(this, DonateGiftAid);

		var _this = _possibleConstructorReturn(this, (DonateGiftAid.__proto__ || Object.getPrototypeOf(DonateGiftAid)).call(this, props));

		_this.state = {
			showhelp: _this.props.isAlreadyEnrolled ? false : _this.props.isChecked,
			isChecked: _this.props.isChecked || false
		};
		_this.handleGiftAidOption = _this.handleGiftAidOption.bind(_this);
		return _this;
	}

	_createClass(DonateGiftAid, [{
		key: 'handleGiftAidOption',
		value: function handleGiftAidOption(ev) {
			var isChecked = ev.target.checked;
			this.setState({
				showhelp: isChecked,
				isChecked: isChecked
			});
			this.props.handleGiftAidOption(isChecked);
		}
	}, {
		key: 'createMarkup',
		value: function createMarkup(content) {
			return {
				__html: content
			};
		}
	}, {
		key: 'render',
		value: function render() {

			var contentMsg = this.props.contentMsg;

			return _react2.default.createElement(
				'div',
				{ className: 'row' },
				_react2.default.createElement(
					'div',
					{ className: 'col-xs-12 col-sm-12 col-md-12' },
					_react2.default.createElement(
						'div',
						{ className: '' + (0, _aphrodite.css)(styles.centered) },
						_react2.default.createElement(
							'div',
							{ className: '' + (0, _aphrodite.css)(styles.giftaidit) },
							_react2.default.createElement('img', { className: '' + (0, _aphrodite.css)(styles.imgWrapper), src: 'https://www.paypalobjects.com/webstatic/ppgf/giftaid/GiftAidWPS.png', alt: 'giftaidit' }),
							_react2.default.createElement('p', { className: '' + (0, _aphrodite.css)(styles.giftaidNote), dangerouslySetInnerHTML: this.createMarkup(contentMsg.extraCost) }),
							this.props.isAlreadyEnrolled && _react2.default.createElement(
								'div',
								{ className: (0, _aphrodite.css)(styles.alreadyEnabled) },
								_react2.default.createElement('span', { className: 'icon icon-positive-large icon-medium ' + (0, _aphrodite.css)(styles.successIcon) }),
								_react2.default.createElement(
									'span',
									null,
									contentMsg.alreadyDone
								),
								_react2.default.createElement('a', { href: '#', className: 'icon icon-small icon-tooltip-outline-small ' + (0, _aphrodite.css)(styles.helpIcon), 'aria-hidden': 'true', id: 'tiphelpIcon',
									'data-toggle': 'modal',
									'data-target': '#giftaiditModal' }),
								this.props.isMember && _react2.default.createElement(
									'p',
									{ className: '' + (0, _aphrodite.css)(styles.updateGiftAidDeclaration) },
									contentMsg.updateGiftAidDeclaration
								)
							),
							!this.props.isAlreadyEnrolled && _react2.default.createElement(
								'div',
								{ className: 'vx_checkbox' },
								_react2.default.createElement('input', { type: 'checkbox', name: 'giftaidCheckbox', id: 'giftaidCheckbox',
									onChange: this.handleGiftAidOption, checked: this.state.isChecked }),
								_react2.default.createElement(
									'label',
									{ htmlFor: 'giftaidCheckbox', className: (0, _aphrodite.css)(styles.toolCheckbox) },
									contentMsg.optGiftaid
								),
								_react2.default.createElement('a', { href: '#', className: 'icon icon-small icon-tooltip-outline-small ' + (0, _aphrodite.css)(styles.helpIcon), 'aria-hidden': 'true', id: 'tiphelpIcon',
									'data-toggle': 'modal',
									'data-target': '#giftaiditModal' })
							),
							this.state.showhelp && _react2.default.createElement(
								'div',
								null,
								_react2.default.createElement(
									'div',
									{ className: '' + (0, _aphrodite.css)(styles.showHelp) },
									_react2.default.createElement(
										'p',
										{ className: '' + (0, _aphrodite.css)(styles.pTag) },
										contentMsg.applyGiftAid
									)
								),
								this.props.showAddress && _react2.default.createElement(
									'div',
									{ className: '' + (0, _aphrodite.css)(styles.showAddres) },
									_react2.default.createElement(
										'p',
										null,
										_react2.default.createElement(
											'b',
											null,
											contentMsg.taxpayer
										)
									),
									_react2.default.createElement(
										'ul',
										{ className: 'list-unstyled ' + (0, _aphrodite.css)(styles.listUnstyled) },
										_react2.default.createElement(
											'li',
											{ className: '' + (0, _aphrodite.css)(styles.liTag) },
											this.props.addressData.fullName
										),
										_react2.default.createElement(
											'li',
											{ className: '' + (0, _aphrodite.css)(styles.liTag) },
											this.props.addressData.address1
										),
										_react2.default.createElement(
											'li',
											{ className: '' + (0, _aphrodite.css)(styles.liTag) },
											this.props.addressData.address2
										),
										_react2.default.createElement(
											'li',
											{ className: '' + (0, _aphrodite.css)(styles.liTag) },
											this.props.addressData.city
										),
										_react2.default.createElement(
											'li',
											{ className: '' + (0, _aphrodite.css)(styles.liTag) },
											this.props.addressData.state,
											', ',
											this.props.addressData.zip
										)
									)
								),
								_react2.default.createElement(
									'div',
									{ className: '' + (0, _aphrodite.css)(styles.showHelp) },
									_react2.default.createElement(
										'p',
										{ className: '' + (0, _aphrodite.css)(styles.pTag) },
										contentMsg.confirmNote
									),
									this.props.isMember && _react2.default.createElement(
										'p',
										{ className: '' + (0, _aphrodite.css)(styles.updateGiftAidDeclaration) },
										contentMsg.updateGiftAidDeclaration
									)
								)
							)
						)
					)
				),
				_react2.default.createElement(
					'div',
					{ className: 'modal fade donate_dialog', id: 'giftaiditModal', role: 'dialog', 'aria-labelledby': 'giftaiditModalLabel' },
					_react2.default.createElement(
						'div',
						{ className: 'modal-dialog', role: 'document' },
						_react2.default.createElement(
							'div',
							{ className: 'modal-content ' + (0, _aphrodite.css)(styles.modalContent) },
							_react2.default.createElement(
								'div',
								{ className: 'modal-header text-right ' + (0, _aphrodite.css)(styles.modalHeader) },
								_react2.default.createElement('a', { href: '#', 'data-dismiss': 'modal', className: 'closeBtn icon icon-close-small' })
							),
							_react2.default.createElement(
								'div',
								{ className: 'modal-body' },
								_react2.default.createElement(
									'h3',
									{ className: 'text-center' },
									contentMsg.howitworks
								),
								_react2.default.createElement(
									'p',
									{ className: '' + (0, _aphrodite.css)(styles.pTag) },
									contentMsg.modalp1
								),
								_react2.default.createElement(
									'p',
									{ className: '' + (0, _aphrodite.css)(styles.pTag) },
									contentMsg.modalp2
								),
								_react2.default.createElement(
									'p',
									{ className: '' + (0, _aphrodite.css)(styles.pTag) },
									contentMsg.modalp3
								),
								_react2.default.createElement(
									'p',
									{ className: '' + (0, _aphrodite.css)(styles.pTag) },
									contentMsg.modalp4
								),
								_react2.default.createElement(
									'div',
									{ className: 'text-center' },
									_react2.default.createElement(
										'span',
										{ className: 'btn vx_btn', 'data-dismiss': 'modal' },
										contentMsg.ok
									)
								)
							)
						)
					)
				)
			);
		}
	}]);

	return DonateGiftAid;
}(_react2.default.Component);

DonateGiftAid.propTypes = {
	isAlreadyEnrolled: _propTypes2.default.bool,
	showAddress: _propTypes2.default.bool,
	addressData: _propTypes2.default.any,
	isChecked: _propTypes2.default.bool,
	handleGiftAidOption: _propTypes2.default.func,
	contentMsg: _propTypes2.default.object,
	isMember: _propTypes2.default.bool
};

exports.default = DonateGiftAid;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/guest-payment/dist/components/Donategiftaid.js
// module id = 700
// module chunks = 5